import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LoaderState {
  active: boolean;
}

export const initialState: LoaderState = {
  active: false,
};

const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    showLoader: (state, action: PayloadAction<undefined>) => {
      state.active = true;
    },
    hideLoader: (state, action: PayloadAction<undefined>) => {
      state.active = false;
    },
  },
});

export const { showLoader, hideLoader } = loaderSlice.actions;

export default loaderSlice.reducer;
